package pwgs.ui.scenes.playerlogsscene

import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.dom.div
import visage.dom.tag
import visage.ds.colorpalette.Skin
import visage.ds.components.*
import visage.ds.utils.EFontWeight
import kotlin.js.Date

class MPlayerLogsScene(props: PlayerLogsSceneProps) : AScene<PlayerLogsSceneProps, PlayerLogsSceneModel, PlayerLogsSceneState, PlayerLogsControllerFe>(props) {

    override fun createController() : PlayerLogsControllerFe {
        return PlayerLogsControllerFe(props, this)
    }

    override fun initState() : PlayerLogsSceneState {
        return PlayerLogsSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val model = this@MPlayerLogsScene.model
        val controller = this@MPlayerLogsScene.controller
        Card {
            isLoading = model.isLoading
            header("Logs") {
                if (model.isLoggingEnabled) {
                    ResponsiveButton("toggle_on", "Disable logs", EButtonColor.Success) {
                        controller.disableLogging()
                    }
                    ResponsiveButton("refresh", "Refresh", EButtonColor.Secondary) {
                        controller.refresh()
                    }
                }
                else {
                    ResponsiveButton("toggle_off", "Enable logs", EButtonColor.Warning) {
                        controller.enableLogging()
                    }
                }
            }

            body {
                ExpandableTable {
                    columns {
                        column("Type")
                        column("Message")
                        column("Date")
                    }
                    body {
                        model.items.forEach {
                            row {
                                val textStyle = when (it.type) {
                                    "Info" -> TextStyle(16, EFontWeight.Regular, Skin.palette.normalTextColor, false)
                                    "Warning" -> TextStyle(16, EFontWeight.Regular, Skin.palette.warningColor, false)
                                    "Error" -> TextStyle(16, EFontWeight.Regular, Skin.palette.dangerColor, false)
                                    "Exception" -> TextStyle(16, EFontWeight.Regular, Skin.palette.errorColor, false)
                                    else -> TextStyle(16, EFontWeight.Regular, Skin.palette.normalTextColor, false)
                                }
                                cell {
                                    Text(it.type, textStyle, false)
                                }
                                cell {
                                    Text(it.content, textStyle, true)
                                }
                                cell {
                                    Text(Date(it.createdAt).toLocaleString(), textStyle, false)
                                }
                                expandableContent {
                                    div {
                                        style.apply {
                                            width = "100%"
                                            padding = "16px"
                                        }

                                        Text("Stack trace:", ETextStyles.Strong)
                                        tag("div") {
                                            style.apply {
                                                whiteSpace = "pre"
                                                width = "100%"
                                                maxWidth = "100%"
                                                color = Skin.palette.normalTextColor
                                                overflowX = "hidden"
                                            }
                                            +it.stackTrace
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

class PlayerLogsSceneState {

}

fun Components.PlayerLogsScene(props: PlayerLogsSceneProps) = this.registerComponent(MPlayerLogsScene(props), {})
